module.exports = __webpack_public_path__ + "static/img/sidebar_newbg.1b888aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sidebar_newbg.png
// module id = OKWe
// module chunks = 1